import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import EngineerLayout from "./components/EngineerLayout";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NewComplaint from "./pages/NewComplaint";
import Complaints from "./pages/Complaints";
import ComplaintDetail from "./pages/ComplaintDetail";
import EngineerView from "./pages/EngineerView";
import EngineerProfile from "./pages/EngineerProfile";
import Reports from "./pages/Reports";
import SettingsPage from "./pages/SettingsPage";
import Team from "./pages/Team";
import Export from "./pages/Export";
import PublicTrack from "./pages/PublicTrack";

function Protected({ children, roles }) {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking)
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "engineer" ? "/engineer" : "/"} replace />;
  }
  const Shell = user.role === "engineer" ? EngineerLayout : Layout;
  return <Shell>{children}</Shell>;
}

function HomeRedirect() {
  const { user, checking } = useAuth();
  if (checking) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "engineer") return <Navigate to="/engineer" replace />;
  return (
    <Protected roles={["admin", "frontdesk"]}>
      <Dashboard />
    </Protected>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/track" element={<PublicTrack />} />
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/complaints/new" element={<Protected roles={["admin", "frontdesk"]}><NewComplaint /></Protected>} />
          <Route path="/complaints" element={<Protected roles={["admin", "frontdesk"]}><Complaints /></Protected>} />
          <Route path="/complaints/:id" element={<Protected roles={["admin", "frontdesk", "engineer"]}><ComplaintDetail /></Protected>} />
          <Route path="/engineer" element={<Protected roles={["engineer", "admin"]}><EngineerView /></Protected>} />
          <Route path="/engineer/profile" element={<Protected roles={["engineer", "admin"]}><EngineerProfile /></Protected>} />
          <Route path="/reports" element={<Protected roles={["admin", "frontdesk"]}><Reports /></Protected>} />
          <Route path="/team" element={<Protected roles={["admin"]}><Team /></Protected>} />
          <Route path="/export" element={<Protected roles={["admin"]}><Export /></Protected>} />
          <Route path="/settings" element={<Protected roles={["admin"]}><SettingsPage /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
